import PropTypes from 'prop-types';

import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableRow 
} from '@mui/material';

const NetProfitAndLoss = ({netProfitLossForPeriod}) => {
  return (
    <div className="mb-6">
      <TableContainer 
        sx={{
        borderCollapse: 'separate',
        borderRadius: '15px',
        border: '1px solid rgb(224, 224, 224)',
      }}>
        <Table aria-label="ProfitShareRevenue">
          <TableBody>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Net profit/loss for period</TableCell>
              <TableCell align='right'>{`£${netProfitLossForPeriod.toFixed(2)}`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default NetProfitAndLoss;

NetProfitAndLoss.propTypes = {
	netProfitLossForPeriod: PropTypes.number.isRequired,
};